"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.VISIT_TYPES = exports.SLOTS_SUCCESS_STATUS = exports.SLOTS_LOADING_STATUS = exports.SLOTS_ERROR_STATUS = exports.PROVIDER_TYPES = exports.MAX_BADGE_FIELDS = exports.MAX_AVAILABILITIES_TO_DISPLAY = exports.MAP_LOCATION_FIELDS = exports.LOGGING = exports.DEFAULTS = exports.ALL_LOCATION_HEADERS = void 0;
const DEFAULTS = exports.DEFAULTS = {
  BADGE_FIELDS: [{
    field: 'accepting_new_patients'
  }],
  PROVIDER_RATING_SCALE: 5,
  SUMMARY_DATA: [{
    field: 'specialties',
    subfield: 'specialty',
    secondary_subfield: 'subspecialty'
  }, {
    field: 'hospital_affiliations',
    display_as: 'Affiliations'
  }]
};
const LOGGING = exports.LOGGING = {
  MESSAGE: {
    CALL_TO_ACTION: 'user_action.cta',
    REQUEST_APPOINTMENT: 'user_action.alter_view.request_appointment',
    VIEW_PROVIDER: 'user_action.search_results.view_provider',
    MAP_LINK_CLICKED: 'user_action.search_results.map_link_clicked'
  },
  PAGE_SECTION: {
    PROVIDER_IMAGE: 'provider_image',
    PROVIDER_NAME: 'provider_name',
    REVIEW_COUNT: 'review_count'
  },
  PLACEMENTS: {
    PROVIDER_CARD: 'provider_card'
  }
};
const VISIT_TYPES = exports.VISIT_TYPES = {
  PHONE: 'phone',
  VIDEO: 'video',
  IN_PERSON: 'in_person'
};
const PROVIDER_TYPES = exports.PROVIDER_TYPES = {
  VIRTUAL_CARE: 'Virtual Care'
};
const MAX_BADGE_FIELDS = exports.MAX_BADGE_FIELDS = 3;
const ALL_LOCATION_HEADERS = exports.ALL_LOCATION_HEADERS = ['phone', 'distance'];
const MAP_LOCATION_FIELDS = exports.MAP_LOCATION_FIELDS = ['street1', 'street2', 'suite', 'city', 'state', 'zip'];
const MAX_AVAILABILITIES_TO_DISPLAY = exports.MAX_AVAILABILITIES_TO_DISPLAY = 3;
const SLOTS_LOADING_STATUS = exports.SLOTS_LOADING_STATUS = '@slots/loading';
const SLOTS_SUCCESS_STATUS = exports.SLOTS_SUCCESS_STATUS = '@slots/success';
const SLOTS_ERROR_STATUS = exports.SLOTS_ERROR_STATUS = '@slots/error';